import { mainAPI, handleApiError } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import {
  ComplaintsListRequest,
  ComplaintResponse,
} from "../types/api/complaints";
import { FeedbackStatusUpdateRequest } from "../types/api/feedback";

const path = `/feedback/admin/${process.env.REACT_APP_API_VERSION}/complaints`;

// Жалобы пользователей - Получить список
export function fetchComplaintsList(params: ComplaintsListRequest) {
  return mainAPI.get<ComplaintResponse[]>(`${path}`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => handleApiError(error)
  );
}

// Жалобы пользователей - Изменить статус
export function updateComplaintsStatus(data: FeedbackStatusUpdateRequest) {
  return mainAPI.post(`${path}/status`, data).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}
